// extracted by mini-css-extract-plugin
module.exports = {"handleBox":"school_handleBox__gRZAj","btn":"school_btn__2Gd5M"};